import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "phone-input" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["value"]
const _hoisted_4 = ["placeholder", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("select", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.country) = $event)),
      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.emitValue())),
      disabled: _ctx.disabled,
      title: "Country"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (c) => {
        return (_openBlock(), _createElementBlock("option", {
          key: c.code,
          value: c.code
        }, _toDisplayString(c.code == _ctx.country ? `${c.code} (+${c.dial})` : `${c.name} (+${c.dial})`), 9, _hoisted_3))
      }), 128))
    ], 40, _hoisted_2), [
      [_vModelSelect, _ctx.country]
    ]),
    _withDirectives(_createElementVNode("input", {
      type: "tel",
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.text) = $event)),
      onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onInput())),
      placeholder: _ctx.placeholder,
      disabled: _ctx.disabled,
      autocomplete: "tel"
    }, null, 40, _hoisted_4), [
      [_vModelText, _ctx.text]
    ])
  ]))
}